(function () {
  function refreshHeaderBar() {
    var current = document.getElementById('header-free-shipping-bar');
    if (!current) return;

    fetch(window.routes.cart_url + '?section_id=header')
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var updated = html.getElementById('header-free-shipping-bar');
        if (updated) {
          current.replaceWith(updated);
        }
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, refreshHeaderBar);
})();
